const _i18n_warning = {
  rule_mode_check : {
    EN: `require change to firewall On(Block)`,
    KO: `require change to firewall On(Block)`,
    JP: `ファイアウォールをオン(ブロック)に変更する必要があります`
  }
}

const i18n_toastr = { _i18n_warning }

export default i18n_toastr